// extracted by mini-css-extract-plugin
export default {"sideBar":"parentLayout_sideBar__5dwa7"};